import airshipService from '../services/airship.service';
import { companyService } from '../services/company.service';
import { emailService } from '../services/email.service';
import { featureService } from '../services/feature.service';
import financialService from '../services/financial.service';
import internalService from '../services/internal.service';
import invoiceManagerService from '../services/invoice-manager.service';
import marketingContentService from '../services/marketingContent.service';
import rtsProUsersService from '../services/rtsproUser.service';
import sentinelService from '../services/sentinel.service';
import userService from '../services/user.service';

export const addInterceptorsToServices = async (
  getAccessTokenSilently: () => Promise<string>,
  loginWithRedirect: () => Promise<void>,
) => {
  await Promise.all([
    airshipService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    companyService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    emailService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    featureService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    financialService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    internalService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    invoiceManagerService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    marketingContentService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    rtsProUsersService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    sentinelService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
    userService.addInterceptors(getAccessTokenSilently, loginWithRedirect),
  ]);
};
